{
  "aboutFarmUserPermissions": "Informazioni sulle autorizzazioni degli utenti della fattoria",
  "canControlDevicesRemotely": {
    "displayName": "Utilizzare i telecomandi",
    "extendedDescription": "Invia comandi e richieste diretti ai dispositivi della tua fattoria, che ti consentiranno di controllare i loro interruttori ed eseguire altre azioni."
  },
  "canManageCustomTriggers": {
    "displayName": "Crea connessioni dispositivo",
    "extendedDescription": "Crea, modifica ed elimina connessioni tra dispositivi, comprese le azioni che possono essere attivate se un dispositivo passa da uno stato all'altro."
  },
  "canManageDeviceConfiguration": {
    "displayName": "Modifica configurazioni",
    "extendedDescription": "Crea, modifica ed elimina le calibrazioni dei sensori del dispositivo e le personalizzazioni del dispositivo (ad esempio, il nome visualizzato nell'app del dispositivo)."
  },
  "canManageDeviceNotifications": {
    "displayName": "Crea notifiche personalizzate",
    "extendedDescription": "Imposta degli avvisi per informare il tuo team quando cambia lo stato di un dispositivo."
  },
  "canManageDevicePermissions": {
    "displayName": "Condividi dispositivi",
    "extendedDescription": "Gestisci l'accesso e il controllo di un dispositivo specifico per altri utenti all'interno o all'esterno della tua azienda agricola."
  },
  "canManageFarmAccount": {
    "displayName": "Modifica i dettagli dell'account agricolo",
    "extendedDescription": "Gestire i dettagli relativi all'amministrazione aziendale (ad esempio modificare l'indirizzo indicato dell'azienda agricola)."
  },
  "canManageFields": {
    "displayName": "Gestisci campi",
    "extendedDescription": "Crea, modifica ed elimina i record dei campi della tua azienda agricola e quelli relativi all'irrigazione."
  },
  "canManageJoinCodes": {
    "displayName": "Gestisci i codici di adesione alla fattoria",
    "extendedDescription": "Concedi agli utenti l'accesso e le autorizzazioni al tuo account farm."
  },
  "canManageSchedules": {
    "displayName": "Gestisci le pianificazioni dei dispositivi",
    "extendedDescription": "Crea e modifica azioni una tantum e ricorrenti per i dispositivi."
  },
  "canManageUserPermission": {
    "displayName": "Modifica altre autorizzazioni utente",
    "extendedDescription": "Concedi o revoca le autorizzazioni a livello di farm ad altri utenti nella tua farm."
  },
  "devicePermissionsDescription": "Consentire all'utente di eseguire azioni sui dispositivi della fattoria.",
  "devicePermissionsTitle": "Autorizzazioni del dispositivo",
  "farmPermissionsDescription": "Consentire all'utente di gestire aspetti dell'account della fattoria.",
  "farmPermissionsTitle": "Permessi agricoli",
  "farmUserPermissionsAllowYouTo": "Le autorizzazioni di farm e dispositivo consentono di eseguire determinate azioni all'interno di FarmHQ. Queste autorizzazioni possono essere concesse o revocate da un amministratore di farm.",
  "farmUserPermissionsHelpSummary": "I permessi Farm-User stabiliscono quali azioni possono essere eseguite da un dato utente. Ciò consente a un farm manager di proteggere i propri dispositivi dall'uso improprio da parte di altri (intenzionalmente o meno).\n\nPuò anche liberare il farm manager e gli altri lavoratori agricoli dal doversi preoccupare di intraprendere accidentalmente azioni che potrebbero avere conseguenze indesiderate.",
  "farmUserPermissionsTitle": "Autorizzazioni utente-azienda agricola",
  "permissionDenied": "Permesso negato",
  "thisPermission": "Questa autorizzazione:",
  "youDoNotHavePermission": "Non hai l'autorizzazione per eseguire questa azione. Contatta un amministratore del tuo account per ottenere l'accesso.",
  "youDoNotHavePermissionToAccessThisResource": "Non hai l'autorizzazione per accedere a questa risorsa. Contatta un amministratore del tuo account per ottenere l'accesso."
}
